var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"ma-2"},[_c('img',{attrs:{"id":"google-btn","height":"50px","src":require("../../../assets/images/google_signin.png")},on:{"mouseover":function($event){return _vm.hover(this);},"mouseout":function($event){return _vm.unhover(this);},"click":_vm.init}})])
}
var staticRenderFns = []

export { render, staticRenderFns }